import { render, staticRenderFns } from "./ModalConfirmChangeDevideByRegion.vue?vue&type=template&id=1513e99e&"
import script from "./ModalConfirmChangeDevideByRegion.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmChangeDevideByRegion.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmChangeDevideByRegion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports